<template>
  <div class="row" :id="theme">
    <div class="col-12">
      <div class="mt-lg-n4 mb-lg-n3 page-title-box d-flex align-items-center justify-content-between"
           style="position: relative; text-align: center;">
        <h4 class="mb-0 mt-md-1 mt-lg-0 font-size-18" :style="me.role?.name === 'hospital' ? 'position: absolute' : ''">
          <b-breadcrumb :items="items" class="mt-4 m-lg-0"
            :style="{ fontSize: fontSize, fontWeight: fontWeight, marginTop: marginTop }"></b-breadcrumb>
        </h4>
        <div v-if="me.role?.name === 'hospital'" class="w-100 mt-n5 mt-lg-0" style="margin-left: -20px; font-size: 16px;">
          <span>{{me.facility?.name}} {{me.department?.name}} {{me.information.fullname}}
          </span>
        </div>
        <div class="page-title-right">
          <b-button v-if="showAdd" @click="enableModal" class="btn-lyg pr-1 text-button w-lg">
            {{ titleButtonAdd }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getProfile} from "../helpers/Auth";

const me = getProfile;
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showAdd: {
      type: Boolean,
      default: false,
    },
    showDel: {
      type: Boolean,
      default: false,
    },
    titleButtonDel: {
      type: String,
      default: "",
    },
    titleButtonAdd: {
      type: String,
      default: "",
    },
    fontSize: {
      type: String,
      default: "18px",
    },
    fontWeight: {
      type: String,
      default: "500",
    },
    marginTop: {
      type: String,
      default: "0",
    },
    theme: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      me: me
    }
  },

  created() {
    this.me = getProfile();
  },

  methods: {
    enableModalDel() {
      this.$emit("showModalDel");
    },

    enableModal() {
      this.$emit("showModalAdd");
    },
  },
};
</script>

<style scoped>
* {
  font-family: "Noto Sans JP";
  font-weight: 500 !important;
  color: #1d1d1d;
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  color: #404040;
}

.text-link {
  color: #336aff;
}

.text-style-button-add {
  color: #ffffff !important;
  font-weight: 700;
}
</style>
